import t from "../../utils/translate";

import { STATE_UNSERVICEABLE, STATE_HOTSPOT } from "../../utils/eligibility";

const ineligibleContent = {
  [STATE_UNSERVICEABLE]: {
    href: "https://www.weightwatchers.com/us/how-it-works/points-program",
    applangaKey: t("JS_INELIGIBLE_STATE_UNSERVICEABLE"),
    interpolations: {},
    header: t("JS_COMING_SOON")
  },
  [STATE_HOTSPOT]: {
    href: "",
    applangaKey: t("JS_INELIGIBLE_LONG_WAIT"),
    interpolations: {},
    header: t("JS_LONG_WAIT_TIMES")
  }
};

export default ineligibleContent;
